'use client'

import { usePathname } from 'next/navigation'
import Header from './Header'
import Footer from './Footer'
import PageTransition from '../shared/PageTransition'

import WhatsAppButton from '../shared/WhatsAppButton'

export default function MainLayout({ children, lang  }: { children: React.ReactNode; lang: string }) {
  const pathname = usePathname()

  return (
    <>
      <Header lang={lang} />
      <PageTransition>
        <main key={pathname} className=''>
          {children}
        </main>
      </PageTransition>
      <Footer />
      <WhatsAppButton />
    </>
  )
}